import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/core/services/auth.service';
import { LayoutService } from 'app/core/services/layout/layout.service';

@Component({
  selector: 'app-uw-dashboard',
  templateUrl: './uw-dashboard.component.html',
  styleUrls: ['./uw-dashboard.component.scss']
})
export class UwDashboardComponent implements OnInit {

  constructor(private layoutService: LayoutService,private authService: AuthService,) { }

  ngOnInit() {
    this.layoutService.clearMenu();
    this.authService.callPopUpMessageAfterLogin();
  }

}
